import { TYPOGRAPHY_MIXIN } from 'src/shared/constants/styling-constants'
import styled from 'styled-components'

export const FormLabelStyled = styled('label')`
  display: inline-block;
  margin-bottom: ${({ theme }) => theme.spacing(0.5)};
  color: ${({ theme }) => theme.colors.text.secondary};
  ${TYPOGRAPHY_MIXIN.body1}
`
